import { render, staticRenderFns } from "./ShipmentsPage.vue?vue&type=template&id=5abef820&scoped=true"
import script from "./ShipmentsPage.vue?vue&type=script&lang=js"
export * from "./ShipmentsPage.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsPage.vue?vue&type=style&index=0&id=5abef820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abef820",
  null
  
)

export default component.exports